import {ApiDateTime} from "platformed-client/types";
import {useTime} from "../hooks/time.ts";
import {relativeDateView} from "../utils/time.tsx";
import {Text, TextProps} from "@chakra-ui/react";
import {Tooltip} from "./ui/tooltip";
import FormattedDate from "platformed-components/i18n/FormattedDate";

function RelativeTimeText({dateTime, floor, ...props}: {dateTime: ApiDateTime; floor?: number} & TextProps) {
  const timeText = useTime(relativeDateView(dateTime, floor), [dateTime, floor]);
  return (
    <Tooltip
      content={<FormattedDate date={dateTime} dateStyle="long" timeStyle="medium" />}
      positioning={{placement: "top"}}
    >
      <Text whiteSpace="nowrap" {...props}>
        {timeText}
      </Text>
    </Tooltip>
  );
}

export default RelativeTimeText;
